import { IBilling } from "features/finance/models/Billing";
import { DataType } from "features/configuration/models/ExtensionType";
import { ITellerOperation } from "features/finance/models/TellerOperation";


export interface IRegistration {
    id: number,
    schoolYearClassId: number,
    personId: number,
    registrationCode: string,
    status: string,
    statusDate: Date,
    effectiveDate: Date,
    validationDate: Date,
    arriveOrGoesByBus: boolean,

    isRepeater: boolean,
    isOldStudent: boolean,
    studentFrom: string,

    busDestinationId: number,
    isArrival: boolean,
    isDeparture: boolean,
    busDestinationName: string,

    takeBrunch: boolean,
    order1: number,
    order2: number,
    orderX: number,
    portable1: string,
    portable2: string,
    email1: string,
    email2: string,

    numberOfAbsences: number,
    numberOfDelays: number,

    hasDeparted: boolean,
    departureDate: Date,
    departureType: string,
    departurePurpose: string,
    departureDescription: string,

    isSocialCase: boolean,
    socialCaseReason: string,

    billings: IBilling[],
    tellerOperations: ITellerOperation[],
    registrationExtensions: IRegistrationExtension[],

    base64Picture: string,
    
    firstName: string,
    lastName: string,
    particularSign: string,
    birthDate: Date,
    birthPlace: string,

    fullNameFR: string,
    fullNameEN: string,

    birthCertificateNumber: string,
    civilRegistrar: string,
    birthCertificateDelivrancePlace: string,

    civility: string,
    gender: string,

    studentCode: string,

    defaultLanguage: string,
    nationality: string,
    identificationType: string,
    identificationNumber: string,
    identificationDelivrancePlace: string,
    identificationStartDate: Date,
    identificationEndDate: Date,

    bloodType: string,
    rhesusFactor: string,
    chronicIllnessCode: string,

    hasSpecificNeeds: boolean,
    specificNeedPurposeCode: string,
    hasDisability: boolean,
    disabilityType: string,

    studentName: string,

    schoolYearClassName: string,
    schoolYearName: string,

    schoolYearYear: number,
    schoolYearCategory: string,

    schoolYearId: number,
    studyType: string,

    studySection: string,
    studyLanguage: string,
    schoolYearClassTemplateId: number,
    classTemplateId: number,
    classOrder: number,
    studyCycle: string,

    fatherId: number,
    motherId: number,
    tutorId: number,

    fatherCivility: string,
    motherCivility: string,
    tutorCivility: string,

    fatherGender: string,
    motherGender: string,
    tutorGender: string,

    fatherFirstName: string,
    motherFirstName: string,
    tutorFirstName: string,

    fatherLastName: string,
    motherLastName: string,
    tutorLastName: string,

    fatherBirthDate: Date,
    motherBirthDate: Date,
    tutorBirthDate: Date,

    fatherBirthPlace: string,
    motherBirthPlace: string,
    tutorBirthPlace: string,
    
    fatherParticularSign: string,
    motherParticularSign: string,
    tutorParticularSign: string,

    fatherBirthCertificateNumber: string,
    motherBirthCertificateNumber: string,
    tutorBirthCertificateNumber: string,

    fatherCivilRegistrar: string,
    motherCivilRegistrar: string,
    tutorCivilRegistrar: string,

    fatherName: string,
    motherName: string,
    tutorName: string,

    fatherPortable1: string,
    motherPortable1: string,
    tutorPortable1: string,

    fatherPortable2: string,
    motherPortable2: string,
    tutorPortable2: string,

    fatherEmail1: string,
    motherEmail1: string,
    tutorEmail1: string,

    fatherEmail2: string,
    motherEmail2: string,
    tutorEmail2: string,

    amount: number,
    dueAmount: number,
    unpaidAmount: number,
    amountPaid: number,

    schoolFeesAmount: number,
    schoolFeesAmountPaid: number,
    schoolFeesUnpaidAmount: number,
    dueAmountSchoolFees: number,

    newBillings: IBilling[],
    newArticleBillings: IBilling[],
    newTransportBillings: IBilling[],


    isMarkExcluded: boolean,

    subjects: ISubjectMark[],
    mark: number,
    rank: number,

    currentMarkStatus: string,
    currentAverageMark: number,
    currentRank: number,

    succeededInHigherClass: boolean,

    defaultSuccessMark: number,
    annualAverageMark: number,

    classTemplateLevel: number,

    registrationMaterials: IRegistrationMaterial[],

    // this is for UI purpose
    initialSchoolYearClassId: number
  }

  export interface IRegistrationExtension {
    id: number,
    registrationId: number,
    schoolYearRegistrationExtensionId: number,

    extensionValueId: number,
    extensionDescription: string,
  
  
    type: DataType,
    enumerationCode: string,
  
    value: any
  }

  export interface IRegistrationSheet {
    id: number,
    registrationId: number,
    SchoolYearPeriodId: number,

    isCancelled: boolean,
    cancellationDate: Date,
    cancellationPurpose: string,
    type: 'disciplinary' | 'absence' | 'observation',

    absenceType: string,
    absencePurpose: string,
    absencePurposeDescription: string,
    justifedAbsence: boolean,
    absenceStartDate: Date,
    absenceEndDate: Date,
    absenceDurationUnit: string,
    absenceDurationValue: number,

    disciplinaryType: string,
    disciplinaryEventSummary: string,
    disciplinaryEventDescription: string,
    disciplinaryEventDate: Date,

    observationPurpose: string,
    observationDescription: string,
    observationDate: Date
  }

  export interface IRegistrationSanction {
    id: number,
    registrationSheetId: number,
    sanctionCategoryCode: string,
    description: string,
    
    isCancelled: boolean,
    cancellationPurpose: string,
    type: string,

    sanctionDate: Date,    
  }

  export interface IRegistrationComplaint {
    id: number,
    registrationId: number,
    complaintCategoryCode: string,
    
    summary: string,
    description: string,
    complaintDate: Date,
    assignedTeacherId: number,
    resolutionDate: Date,    
    resolutionDescription: string,
    status: string,
  }


  export interface ISubjectMark {
        
    schoolYearTemplateSubjectId: number,

    subject: string,
    shortName: string,
    longName: string,

    firstName: string,
    lastName: string,

    schoolYearPeriodExamName: string,

    mark1: number,
    mark2: number,
    mark3: number,
    mark4: number,
    mark5: number,
    mark6: number,
    mark7: number,
    mark8: number,
    mark9: number,
    mark10: number,
    mark11: number,
    mark12: number,
    mark13: number,
    mark14: number,
    mark15: number,
    mark16: number,
    mark17: number,
    mark18: number,
    mark19: number,
    mark20: number,

    marks: IMark[],

    mark: number,
    maxMark: number,

    reportCardMark: number,
    coefficient: number,
}

export interface IMark {
  schoolYearPeriodExamName : string,

  examValue: number,
  examMaxValue: number,

  subjectValue: number, // Value reported in the base of max mark of subject
  subjectMaxValue: number, // Max mark for the subject
  subjectValueWeight: number, // The contribution of this mark in the final mark

  reportCardValue: number,
  reportCardMaxValue: number,
  reportCardValueWeight: number,

  coefficient: number,
  weight: number,
}

export interface IRegistrationMaterial {
  id: number,
  registrationId: number,
  schoolMaterialCode: string,
  
  status: string,
  statusDate: Date,
  statusPurpose: string,
}

export interface IRegistrationExcludedSubject {
  id: number,
  registrationId: number,
  schoolYearClassSubjectId: number,
}

  export const defaultRegistration : IRegistration = {
    id: 0,
    schoolYearClassId: 0,
    personId: 0,
    registrationCode: '',
    status: '95',
    statusDate: new Date(),
    effectiveDate: new Date(),
    validationDate: new Date(),
    arriveOrGoesByBus: false,

    isRepeater: false,
    isOldStudent: false,
    studentFrom: '',

    busDestinationId: 0,
    isArrival: false,
    isDeparture: false,
    busDestinationName: '',

    takeBrunch: false,
    order1: 0,
    order2: 0,
    orderX: 0,
    portable1: '',
    portable2: '',
    email1: '',
    email2: '',

    numberOfAbsences: 0,
    numberOfDelays: 0,

    hasDeparted: false,
    departureDate: new Date(),
    departureType: '',
    departurePurpose: '',
    departureDescription: '',

    isSocialCase: false,
    socialCaseReason: '',

    billings: [],
    tellerOperations: [],
    registrationExtensions: [],

    base64Picture: '',

    firstName: '',
    lastName: '',
    particularSign: '',
    birthDate: new Date(),
    birthPlace: '',

    fullNameFR: '',
    fullNameEN: '',

    birthCertificateNumber: '',
    civilRegistrar: '',
    birthCertificateDelivrancePlace: '',

    civility: '',
    gender: '',

    studentCode: '',

    defaultLanguage: '',
    nationality: '',
    identificationType: '',
    identificationNumber: '',
    identificationDelivrancePlace: '',
    identificationStartDate: new Date(),
    identificationEndDate: new Date(),

    bloodType: '',
    rhesusFactor: '',
    chronicIllnessCode: '',

    hasSpecificNeeds: false,
    specificNeedPurposeCode: '',
    hasDisability: false,
    disabilityType: '',


    studentName: '',

    schoolYearClassName: '',
    schoolYearName: '',

    schoolYearYear: 0,
    schoolYearCategory: '',

    schoolYearId: 0,
    studyType: '',

    studySection: '',
    studyLanguage: '',
    schoolYearClassTemplateId: 0,
    classTemplateId: 0,
    classOrder: 0,
    studyCycle: '',

    fatherId: 0,
    motherId: 0,
    tutorId: 0,

    fatherCivility: 'M',
    motherCivility: 'F',
    tutorCivility: '',

    fatherGender: 'Mr',
    motherGender: 'Mme',
    tutorGender: '',


    fatherFirstName: '',
    motherFirstName: '',
    tutorFirstName: '',

    fatherLastName: '',
    motherLastName: '',
    tutorLastName: '',

    fatherBirthDate: new Date(),
    motherBirthDate: new Date(),
    tutorBirthDate: new Date(),

    fatherBirthPlace: '',
    motherBirthPlace: '',
    tutorBirthPlace: '',
    
    fatherParticularSign: '',
    motherParticularSign: '',
    tutorParticularSign: '',

    fatherBirthCertificateNumber: '',
    motherBirthCertificateNumber: '',
    tutorBirthCertificateNumber: '',

    fatherCivilRegistrar: '',
    motherCivilRegistrar: '',
    tutorCivilRegistrar: '',

    fatherName: '',
    motherName: '',
    tutorName: '',

    fatherPortable1: '',
    motherPortable1: '',
    tutorPortable1: '',

    fatherPortable2: '',
    motherPortable2: '',
    tutorPortable2: '',

    fatherEmail1: '',
    motherEmail1: '',
    tutorEmail1: '',

    fatherEmail2: '',
    motherEmail2: '',
    tutorEmail2: '',



    amount: 0,
    dueAmount: 0,
    unpaidAmount: 0,
    amountPaid: 0,

    schoolFeesAmount: 0,
    schoolFeesAmountPaid: 0,
    schoolFeesUnpaidAmount: 0,
    dueAmountSchoolFees: 0,

    newBillings: [],
    newArticleBillings: [],
    newTransportBillings: [],

    isMarkExcluded: false,
    
    subjects: [],

    mark: 0,
    rank: 0,

    currentMarkStatus: '',
    currentAverageMark: 0,
    currentRank: 0,

    succeededInHigherClass: false,

    defaultSuccessMark: 0,
    annualAverageMark: 0,

    classTemplateLevel: 0,
    
    registrationMaterials: [],
    
    // this is for UI purpose
    initialSchoolYearClassId: 0
  }

  export const defaultRegistrationSheet : IRegistrationSheet = {
    id: 0,
    registrationId: 0,
    SchoolYearPeriodId: 0,
    isCancelled: false,
    cancellationDate: new Date(),
    cancellationPurpose: '',

    type: 'disciplinary',
    absenceType: '',
    absencePurpose: '',
    absencePurposeDescription: '',
    justifedAbsence: false,
    absenceStartDate: new Date(),
    absenceEndDate: new Date(),
    absenceDurationUnit: '',
    absenceDurationValue: 0,

    disciplinaryType: '',
    disciplinaryEventSummary: '',
    disciplinaryEventDescription: '',
    disciplinaryEventDate: new Date(),

    observationPurpose: '',
    observationDescription: '',
    observationDate: new Date()
  }

  export const defaultRegistrationSanction : IRegistrationSanction = {
    id: 0,
   
    registrationSheetId: 0,
    sanctionCategoryCode: '',
    description: '',
    isCancelled: false,
    cancellationPurpose: '',
    type: '',

    sanctionDate: new Date(),
  }

  export const defaultRegistrationComplaint : IRegistrationComplaint = {
    id: 0,   
    registrationId: 0,

    complaintCategoryCode: '',
    summary: '',
    description: '',
    complaintDate: new Date(),
    assignedTeacherId: 0,
    resolutionDate: new Date(),    
    resolutionDescription: '',
    status: ''
  }


  
  export interface IStudentDisciplinary {
    registrationId: number,

    fullNameFR: string, 
    fullNameEN: string, 
    conductGrade: number, 
    justifiedAbsence: number,
    unjustifiedAbsence: number,
  
    editJustifiedAbsence: boolean,
    editUnjustifiedAbsence: boolean,

    justifiedAbsenceType: string,
    justifiedAbsencePurpose: string,
    unjustifiedAbsenceType: string,
    unjustifiedAbsencePurpose: string,
  }
  
  export interface ISchoolYearClassDisciplinaryMark {
    schoolYearClassId: number,
    schoolYearPeriodId: number,
  
    schoolYearId: number,
    schoolYearClassTemplateId: number,
    schoolYearStartDate: Date,
    schoolYearEndDate: Date,
  
    schoolYearClassName: string,
  
    studyType : string,
    fullTeacherName : string,
    substituteTeacherName : string,
    classTemplateName : string,
    studyLanguage: string,

    justifiedAbsenceType: string,
    justifiedAbsencePurpose: string,
    unjustifiedAbsenceType: string,
    unjustifiedAbsencePurpose: string,
  
    studentDisciplinaries: IStudentDisciplinary[]
  }
  
  export const defaultSchoolYearClassDisciplinaryMark : ISchoolYearClassDisciplinaryMark = {
    schoolYearClassId: 0,
    schoolYearPeriodId: 0,
  
    schoolYearId: 0,
    schoolYearClassTemplateId: 0,
    schoolYearStartDate: new Date(),
    schoolYearEndDate: new Date(),
  
    schoolYearClassName: '',
  
    studyType : '',
    fullTeacherName : '',
    substituteTeacherName : '',
    classTemplateName : '',
    studyLanguage: '',

    justifiedAbsenceType: '',
    justifiedAbsencePurpose: '',
    unjustifiedAbsenceType: '',
    unjustifiedAbsencePurpose: '',
  
    studentDisciplinaries: []
  }

  export interface IRegistrationDashboard {
    countStudents: number,
    countGirls: number, 
    countBoys: number, 
    countNewStudents: number, 
    countOldStudents: number,
    countPreregistrations: number, 
    countWithdrawnStudents: number, 
    countExpelStudents: number
  }

  export const defaultRegistrationDashboard : IRegistrationDashboard = {
    countStudents: 0,
    countGirls: 0, 
    countBoys: 0, 
    countNewStudents: 0, 
    countOldStudents: 0,
    countPreregistrations: 0, 
    countWithdrawnStudents: 0, 
    countExpelStudents: 0
  }



  export interface IRegistrationSearch {
    schoolYearId: number,
    studyType: string,

    studySection: string,
    studyLanguage: string,

    schoolYearClassName: string,

    firstName: string,
    lastName: string        
  }

  export interface IRegistrationDashboardSearch {
    schoolYearId: number, schoolYearClassTemplateId: number, schoolYearClassId: number,
            studySection: string, studyLanguage: string, studyCycle: string, studyLevel: string, 
            order: number, studyType: string, gender: string, name: string, 
            status: string, statusStartDate: Date, statusEndDate: Date,
           oldStudent: 'Y' | 'N' | ''}  